import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";

const SET_MODAL_OPEN = "noticeModal/SET_MODAL_OPEN";
const SET_CONTENT_MODAL = "noticeModal/SET_CONTENT_MODAL";
const SET_CALLBACK = "noticeModal/SET_CALLBACK";

const setModalOpen = createAction(SET_MODAL_OPEN);
const setContentText = createAction(SET_CONTENT_MODAL);
const setCallback = createAction(SET_CALLBACK);

export const openModal = inputObj => (dispatch, getState) => {
  if (!inputObj || !inputObj.content) {
    throw Error("input doesn't exist");
  }

  const { content, callback } = inputObj;
  dispatch(setContentText(content));
  dispatch(setCallback(callback));
  dispatch(setModalOpen(true));
};

export const closeModal = () => (dispatch, getState) => {
  const { callback } = getState().noticeModal.toJS();
  if (callback) callback();
  dispatch(setModalOpen(false));
  dispatch(setCallback(null));
};

const initialState = fromJS({
  modalOpen: false,
  contentText: null,
  callback: null
});

export default handleActions(
  {
    [SET_MODAL_OPEN]: (state, action) => {
      const modalOpen = action.payload;
      return state.set("modalOpen", fromJS(modalOpen));
    },
    [SET_CONTENT_MODAL]: (state, action) => {
      const contentText = action.payload;
      return state.set("contentText", fromJS(contentText));
    },
    [SET_CALLBACK]: (state, action) => {
      const callback = action.payload;
      return state.set("callback", fromJS(callback));
    }
  },
  initialState
);
